import React from 'react';
import { Container } from './styles';

interface IProps {
  titleValue?: string;
  value?: number;
}

export const CardValue = (props: IProps) => {
  const handleFormatValue = (value: number) => {
    const newValue = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
    }).format(value);

    return newValue;
  };

  return (
    <Container>
      <span>{props.titleValue}:&nbsp;</span>
      <span className="card-value">
        {props.value ? handleFormatValue(props.value) : handleFormatValue(0)}
      </span>
    </Container>
  );
};
